import { useMediaQuery } from 'react-responsive'

export default function MobileSectionHandler({ children, sections, selectedSection, onSectionClose }) {
    const isMobile = useMediaQuery({ query: '(max-width: 568px)' })

    const section = sections[selectedSection] || null;

    return children.map((child, index) => <div key={index} className={`layout__inner-container`}>{ child }</div>)
}
